import styled from 'styled-components';

import { Typography } from 'src/app/components/Elements/Typography';

export const MailSubTitle = styled(Typography)`
  color: ${props => props.theme.colors.capsuleGreen60} !important;

  font-style: normal !important;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;
  font-size: ${props => props.theme.fontSizes.headerFour} !important;
  letter-spacing: ${props => props.theme.letterSpacings.one} !important;
  line-height: ${props => props.theme.space['1.25']} !important;

  padding-bottom: ${props => props.theme.space['1.5']} !important;
`;

export const MailTitle = styled(Typography)`
  color: ${props => props.theme.colors.capsuleBlue50} !important;

  font-style: normal !important;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.bold} !important;
  font-size: ${props => props.theme.fontSizes.displayXL} !important;
  letter-spacing: ${props => props.theme.letterSpacings.one} !important;
  line-height: ${props => props.theme.lineHeights.displayXL} !important;

  padding-top: ${props => props.theme.space['1.5']} !important;
  padding-bottom: ${props => props.theme.space.none} !important;
`;

export const OnfleetIframeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 3rem;
`;

export const OnfleetIframe = styled.iframe`
  border: none;
`;
